import React, { useState } from "react";
import { Link, useHistory }  from 'react-router-dom';
import { Auth } from '../../../index'
import "./reset-pwd.css"
import "../auth.css"

const ResetPwd = () => {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");

    const handleResetPwd = () => {
        setMessage("");
        Auth.sendPasswordResetEmail(email)
        .then((res) => {
            setMessage("We’ve sent an email to your UW email inbox. Please follow the instruction in the email.");
        })
        .catch(() => {
            setMessage("Error in resetting Password. Please try again")
        })
    }

    return (
        <div id='outer-container'>
            <div id='form-container-pwd' role="reset">

                <h1 style={{
                            'color': 'rgba(0, 0, 0, 1)',
                            'left': '16em',
                            'top': '3.4em',
                            'font-family': 'Open Sans',
                            'font-style': 'normal',
                            'font-weight': '600',
                            'font-size': '2.4em',
                            'line-height': '3em',
                            'margin': '0'
                            }}>
                                Forgot password?
                                </h1>
                <h1 style={{
                    'height': '1em',
                    'color': '#625FA1',
                    'left': '30em',
                    'top': '12em',
                    'font-family': 'Open Sans',
                    'font-style': 'normal',
                    'font-weight': '600',
                    'font-size': '1.2em',
                    'line-height': '33px',
                    'text-align': 'center',
                    'margin-top':'0',
                    'margin-bottom':'5em'
                    }}>No worries! Let’s reset your password now.</h1>
                <text
                style={{
                    'height': '1em',
                    'color': '#000000',
                    'left': '37em',
                    'top': '23em',
                    'font-family': 'Open Sans',
                    'font-style': 'normal',
                    'font-weight': '600',
                    'font-size': '1em',
                    'line-height': '33px',
                    'text-align': 'left',
                    'padding-left': '17em'
                    }}> Please enter your UW email.</text>
                <form>
                    <>
                        <div className="form-group">
                        <label htmlFor="email"></label>
                        <input className="form-control"
                            id="email"
                            type="email"
                            name="email"
                            style = {{
                                'width': '28em'
                                }}
                            placeholder='......@uw.edu'
                            onChange={(event) => {
                                setEmail(event.target.value)
                            }}
                            />
                        </div>

                        {/* buttons */}
                        <div id="button-container">
                            <button
                                className="btn btn-primary mr-2"
                                style = {{

                                    'left': 'center',
                                    'top': '27em',
                                    'margin-top':'3em',
                                    'width': '17.6em',
                                    'height': '2.4em',
                                    'background': 'linear-gradient(92.83deg, #EFCAC6 0%, rgba(255, 255, 255, 0) 100%), #7370BB',
                                    'border-radius': '45px',
                                    'border': 'none',
                                    'font-size': 'large',
                                    'color': '#FFFFFF'
                                    }}
                                onClick={e => {
                                    e.preventDefault()
                                    handleResetPwd();
                                }}>
                                Send me an email
                            </button>

                        </div>
                    </>
                </form>
                <p>{message}</p>
            </div>
        </div>
    );
}

export default ResetPwd;